import { type VideoFormState, VideoOption, type VideoSkipabilityPayload } from '@openx/types/targeting/video';
import { noop } from '@openx/utils/noop';
import { type JSX, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FiltersTitle } from '../../../shared/FiltersTitle/FiltersTitle';
import { SelectedItems } from '../../../shared/SelectedItems/SelectedItems';
import { getVideoSkipabilityOptions } from '../../utils/utils';

type VideoSkipabilityItemProps = {
  readonly?: boolean;
  params: VideoSkipabilityPayload;
  onChange?: (newData: VideoFormState | ((prevState: VideoFormState) => VideoFormState)) => void;
  disabledReasonMessage?: string;
};

export const VideoSkipabilityItem = ({
  params,
  readonly = true,
  onChange = noop,
  disabledReasonMessage,
}: VideoSkipabilityItemProps): JSX.Element => {
  const { t } = useTranslation();

  const videoOptions = useMemo(() => getVideoSkipabilityOptions(t), [t]);
  const { val } = params;

  const handleChange = useCallback(() => {
    onChange(state => ({
      ...state,
      [VideoOption.VIDEO_SKIPABILITY]: null,
    }));
  }, [onChange]);

  return (
    <>
      <FiltersTitle
        onClear={handleChange}
        title={t('Video Skippability')}
        readonly={readonly}
        disabledReasonMessage={disabledReasonMessage}
      />
      <SelectedItems
        isAddIcon
        selectedItems={[val]}
        readonly={readonly}
        handleChange={handleChange}
        options={videoOptions}
        dataTest="skippable-video"
      />
    </>
  );
};
